<!-- Item wrapper -->
<div
    class="fuse-vertical-navigation-item-wrapper"
    [class.fuse-vertical-navigation-item-has-subtitle]="!!item.subtitle"
    [ngClass]="item.classes?.wrapper"
>
    <!-- Item with an internal link -->
    <ng-container
        *ngIf="
            item.link && !item.externalLink && !item.function && !item.disabled
        "
    >
        <a
            class="fuse-vertical-navigation-item"
            [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active
            }"
            [routerLink]="[item.link]"
            [fragment]="item.fragment ?? null"
            [preserveFragment]="item.preserveFragment ?? false"
            [queryParams]="item.queryParams ?? null"
            [queryParamsHandling]="item.queryParamsHandling ?? null"
            [routerLinkActive]="'fuse-vertical-navigation-item-active'"
            [routerLinkActiveOptions]="isActiveMatchOptions"
            [matTooltip]="item.tooltip || ''"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    </ng-container>

    <!-- Item with an external link -->
    <ng-container
        *ngIf="
            item.link && item.externalLink && !item.function && !item.disabled
        "
    >
        <a
            class="fuse-vertical-navigation-item"
            [href]="item.link"
            [target]="item.target || '_self'"
            [matTooltip]="item.tooltip || ''"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    </ng-container>

    <!-- Item with a function -->
    <ng-container *ngIf="!item.link && item.function && !item.disabled">
        <div
            class="fuse-vertical-navigation-item"
            [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active
            }"
            [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Item with an internal link and function -->
    <ng-container
        *ngIf="
            item.link && !item.externalLink && item.function && !item.disabled
        "
    >
        <a
            class="fuse-vertical-navigation-item"
            [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active
            }"
            [routerLink]="[item.link]"
            [fragment]="item.fragment ?? null"
            [preserveFragment]="item.preserveFragment ?? false"
            [queryParams]="item.queryParams ?? null"
            [queryParamsHandling]="item.queryParamsHandling ?? null"
            [routerLinkActive]="'fuse-vertical-navigation-item-active'"
            [routerLinkActiveOptions]="isActiveMatchOptions"
            [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    </ng-container>

    <!-- Item with an external link and function -->
    <ng-container
        *ngIf="
            item.link && item.externalLink && item.function && !item.disabled
        "
    >
        <a
            class="fuse-vertical-navigation-item"
            [href]="item.link"
            [target]="item.target || '_self'"
            [matTooltip]="item.tooltip || ''"
            (click)="item.function(item)"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </a>
    </ng-container>

    <!-- Item with a no link and no function -->
    <ng-container *ngIf="!item.link && !item.function && !item.disabled">
        <div
            class="fuse-vertical-navigation-item"
            [ngClass]="{
                'fuse-vertical-navigation-item-active-forced': item.active
            }"
            [matTooltip]="item.tooltip || ''"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>

    <!-- Item is disabled -->
    <ng-container *ngIf="item.disabled">
        <div
            class="fuse-vertical-navigation-item fuse-vertical-navigation-item-disabled"
            [matTooltip]="item.tooltip || ''"
        >
            <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
        </div>
    </ng-container>
</div>

<!-- Item template -->
<ng-template #itemTemplate>
    <!-- Icon -->
    <ng-container *ngIf="item.icon">
        <mat-icon
            class="fuse-vertical-navigation-item-icon material-symbols-outlined"
            [ngClass]="item.classes?.icon"
            >{{ item.icon }}</mat-icon
        >
    </ng-container>

    <!-- Checkbox -->
    <ng-container *ngIf="item.checkbox">
        <div class="fuse-vertical-navigation-item-checkbox">
            <div class="fuse-vertical-navigation-item-checkbox-content">
                <mat-checkbox
                    [(ngModel)]="item.checkbox.checked"
                    (ngModelChange)="checkboxChange($event)"
                    [color]="
                        item?.checkbox?.color ? item.checkbox.color : 'primary'
                    "
                >
                    <div
                        class="fuse-vertical-navigation-item-title-wrapper cursor-pointer"
                    >
                        <div class="fuse-vertical-navigation-item-title  w-56">
                            <span [ngClass]="item.classes?.title">
                                {{ item.title }}
                            </span>
                        </div>
                        <ng-container *ngIf="item.subtitle">
                            <div class="fuse-vertical-navigation-item-subtitle">
                                <span [ngClass]="item.classes?.subtitle">
                                    {{ item.subtitle }}
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </mat-checkbox>
            </div>
        </div>
    </ng-container>

    <!-- Radio -->

    <ng-container *ngIf="item.radio">
        <div class="fuse-vertical-navigation-item-radio">
            <div class="fuse-vertical-navigation-item-radio-content ">
                <mat-radio-button
                    [color]="item?.radio?.color ? item.radio.color : 'primary'"
                    [value]="item.id"
                    (change)="setValue(item)"
                >
                    <div
                        class="fuse-vertical-navigation-item-title-wrapper cursor-pointer"
                    >
                        <div class="fuse-vertical-navigation-item-title w-56">
                            <span [ngClass]="item.classes?.title">
                                {{ item.title }}
                            </span>
                        </div>
                        <ng-container *ngIf="item.subtitle">
                            <div class="fuse-vertical-navigation-item-subtitle">
                                <span [ngClass]="item.classes?.subtitle">
                                    {{ item.subtitle }}
                                </span>
                            </div>
                        </ng-container>
                    </div>
                </mat-radio-button>
            </div>
        </div>
    </ng-container>

    <!-- Title & Subtitle -->
    <div
        class="fuse-vertical-navigation-item-title-wrapper"
        *ngIf="!item.radio && !item.checkbox"
    >
        <div class="fuse-vertical-navigation-item-title">
            <span [ngClass]="item.classes?.title"> {{ item.title }}</span>
        </div>
        <ng-container *ngIf="item.subtitle">
            <div class="fuse-vertical-navigation-item-subtitle">
                <span [ngClass]="item.classes?.subtitle">
                    {{ item.subtitle }}
                </span>
            </div>
        </ng-container>
    </div>

    <!-- Badge -->
    <ng-container *ngIf="item.badge">
        <div class="fuse-vertical-navigation-item-badge">
            <div
                class="fuse-vertical-navigation-item-badge-content"
                [ngClass]="item.badge.classes"
            >
                {{ item.badge.title }}
            </div>
        </div>
    </ng-container>
</ng-template>
